import { useCallback, useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { useInfo } from "@/context/InfoContext";
import { inputCls } from "@/pages/admin/AdminServices";

export default function AdminClients() {
  const api = useApi();
  const { me } = useInfo();
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");

  const load = useCallback(() => api("get", "/users").then(setData).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => {
    load();
  }, [load]);

  const setRole = async (u, role) => {
    try { await api("patch", `/users/${u.user_id}/role`, { role }); toast.success("Rol actualizado"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!data) return <Loader2 className="w-5 h-5 animate-spin text-zinc-400" />;
  const users = data.users.filter((u) => `${u.name} ${u.email}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="admin-clients">
      <div className="relative max-w-sm mb-6">
        <Search className="w-4 h-4 absolute left-3 top-3 text-zinc-400" />
        <input placeholder="Buscar por nombre o correo" className={`${inputCls} w-full pl-9`} value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-clients-search" />
      </div>
      <p className="text-sm text-zinc-500 mb-4">{data.users.length} cuentas registradas. Los puntos se suman al marcar una cita como completada y pagada.</p>
      {users.length === 0 ? <p className="text-sm text-zinc-400" data-testid="admin-no-clients">Sin resultados.</p> : (
        <ul className="divide-y divide-zinc-200 border-y border-zinc-200">
          {users.map((u) => (
            <li key={u.user_id} className="py-4 grid grid-cols-1 md:grid-cols-12 gap-3 items-center" data-testid={`admin-client-${u.email}`}>
              <div className="md:col-span-4"><p className="font-semibold">{u.name || "—"}</p><p className="text-sm text-zinc-500">{u.email}</p></div>
              <div className="md:col-span-2"><p className="font-mono text-2xl" data-testid={`admin-client-points-${u.email}`}>{u.points}</p><p className="text-xs text-zinc-400">puntos</p></div>
              <div className="md:col-span-2 text-sm text-zinc-600">{u.bookings.total} citas<br /><span className="text-xs text-zinc-400">{u.bookings.completed} completadas</span></div>
              <div className="md:col-span-2 text-sm">
                {u.rewards.length === 0 ? <span className="text-zinc-400 text-xs">Sin recompensas</span> : u.rewards.map((r) => (
                  <span key={r.id} className="block font-mono text-xs">{r.code} · {r.status === "available" ? "disponible" : "utilizada"}</span>
                ))}
              </div>
              <div className="md:col-span-2">
                <select value={u.role} disabled={u.user_id === me?.user_id} onChange={(e) => setRole(u, e.target.value)} className={`${inputCls} w-full`} data-testid={`admin-client-role-${u.email}`}>
                  {data.roles.map((r) => <option key={r} value={r}>{r === "admin" ? "Administrador" : "Cliente"}</option>)}
                </select>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
